import { ReferAFriendModalContentFragment } from '@/models/cms';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { RewardsPageLoadEvent } from '@/services/analytics/events/rewards-page-load-event';
import { RewardsLinkClickedEvent } from '@/services/analytics/events/rewards-link-clicked-event';

@Component({
    name: 'CmgReferAFriendModal'
})

export default class CmgReferAFriendModal extends Vue {
    private isExpanded: boolean = false;
    referAFriendModal: ReferAFriendModalContentFragment = {};
    firedLinkClickedEvent = false;

    get isRewardsReferralProgramEnabled(): boolean {
        return this.$appStore.state.featureFlags.featureFlags.isRewardsReferralProgramEnabled;
    }

    @Watch('isRewardsReferralProgramEnabled', { immediate: true })
    async onRewardsReferralProgramEnabledChange(newValue: boolean) {
        if (newValue) {
            await this.$services.config.setReferAFriendModal();
            this.referAFriendModal = this.$services.config.getReferAFriendModal() || {};
        }
    }

    @Watch('visible', { immediate: true })
    onVisibleChange(newValue: boolean) {
        if (newValue) {
            this.$services.analytics.send(new RewardsPageLoadEvent('refer-a-friend'));        
        }
    }

    async mounted() {
        this.$services.ui.firstFocus();
    }

    get visible(): boolean {
        return this.$appStore.state.ui.modals.referAFriendModal.visible;
    }

    get isMobile(): boolean {
        return this.$services.ui.isMobile();
    }

    get chevronIcon(): string {
        return this.$appStore.state.cms.images.icons.chevronLeftPlain.default;
    }

    get title(): string {
        return this.referAFriendModal.title || 'Refer a friend';
    }

    get description(): string {
        return this.referAFriendModal.subtitle || 'Get 100 Points when someone joins Chipotle Rewards using your referral link and places their first order over $10. Your friend also gets 100 points.';
    }

    get ctaText(): string {
        return 'Copy link';
    }

    get termsAndConditionsHeader(): string {
        return this.referAFriendModal.termsAndConditionsSubheader || 'Terms & Conditions';
    }

    get termsAndConditionsBody(): string {
        return this.referAFriendModal.termsAndConditionsBody || '';
    }

    get shortReferralLink(): string {
        return !!this.customerIdHash
            ? `${window.location.host}/order/referrals?cref=${this.customerIdHash}`
            : '';
    }

    get longReferralLink(): string {
        return !!this.customerIdHash
            ? `${window.location.origin}/order/referrals?cref=${this.customerIdHash}`
            : '';
    }

    get referralMedallionImg(): string {
        return this.$appStore.state.cms.images.logos.medallionReferral.default;
    }

    get customerIdHash(): string {
        return this.$appStore.state.customer.profile?.customerIdHash || '';
    }

    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
    }

    async onClickCopyReferralLink() {
        const text = this.longReferralLink;
        if (!text) return;

        if(!this.firedLinkClickedEvent) {
            this.firedLinkClickedEvent = true;

            this.$services.analytics.applyOne({
                account: {
                    rewardsReferAFriend: { value: 1 }
                }
            })
            this.$services.analytics.send(new RewardsLinkClickedEvent('refer-a-friend', this.ctaText));
        }

        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(this.longReferralLink);
            return;
        }

        // fallback
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'true');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            document.execCommand('copy');
        } finally {
            document.body.removeChild(textarea);
        }
    }

    onClose() {
        this.firedLinkClickedEvent = false;
        this.$services.ui.setModalVisibility('referAFriendModal', false);
    }
}
